/* MovieCreator.js */
/* @author: anghello */
/* v. 1.1 */

import PSO from "../services/PSO";
import WAM from "../services/WAM";
import RemixHelper from "../helpers/RemixHelper";
import Strings from "../translations/Translations";
import { MovieJSONBuilder } from "../helpers/MovieJSONBuilder";

const BASE_APP = process.env.REACT_APP_NAME;
const BASE_CLIENT = process.env.REACT_APP_CLIENT;
const normalUserMaxPhotos = 30;
const normalUserMaxMovieDurationSeconds = 180;
const defaultFrameRate = 30;
const defaultTitleDurationFrames = 150;
const defaultEndingDurationFrames = 90;
const defaultImagesDurationFrames = 90;

const timeout = (ms) => { return new Promise(resolve => setTimeout(resolve, ms)); }

export const MovieCreator = async ({ al, un, rid }) => {
  let returnV = true, errorMessage = null, movieCreated;
  let albumId = null, movieId = null, movieUrl = null, albumPermission = null, movieMakeTime = null;
  let movieDurationSeconds = 0;
  let userData = null; let proUser = false;
  let remixPars = null, allDataRemixPars = null, nPhotos = 0, movieJson = null;
  let rmxElementIds = [], rmxElementTypes = [], rmxFileNames = [], rmxPhotoSortOrderIds = [];
  let rmxId = null, rmxMediaOnly = null;
  let uploadStatusCount = 0;
  const secondsToWait = 3;
  let albumCover;

  // Validating the user section
  if (returnV) {
    try {
      const response = await WAM.validateSession({ un, al });
      if (response.result !== 'success') {
        returnV = false;
        if (response.error) { errorMessage = response.error; }
        else { errorMessage = Strings('error_while_validating_login'); }
      }
    } catch (err) {
      returnV = false;
      console.error(err);
    }
  }

  // Getting the remix pars
  if (returnV) {
    try {
      const response = await PSO.getRemixPars({ un, al, rid, getappelements: 1 });
      if (response.result === 'success' && response.its && response.its.length > 0) {
        remixPars = response.its[0];
        allDataRemixPars = response;
      } else {
        returnV = false;
      }
    } catch (err) {
      returnV = false;
      console.error(err);
    }
  }

  // Getting the user data
  if (returnV) {
    try {
      const response = await PSO.getUserData({ un, al, cid: un });
      if (response && response.result === 'success') {
        userData = response;
      } else {
        returnV = false;
      }
    } catch (err) {
      console.error(err);
      returnV = false;
    }
  }

  // Getting number of Photos
  if (returnV && allDataRemixPars && allDataRemixPars.getRemixApprovedElements && allDataRemixPars.getRemixApprovedElements.its_media) {
    nPhotos = allDataRemixPars.getRemixApprovedElements.its_media.length;
  } else {
    returnV = false;
  }

  // Calculating total movie duration
  if (returnV && nPhotos) {
    movieDurationSeconds += defaultTitleDurationFrames / defaultFrameRate;
    movieDurationSeconds += defaultEndingDurationFrames / defaultFrameRate;

    const remixMedia = allDataRemixPars.getRemixApprovedElements.its_media;
    remixMedia.forEach((media) => {
      if (media.etype === 1) {
        // Photo
        movieDurationSeconds += defaultImagesDurationFrames / defaultFrameRate;
      } else if (media.etype === 2) {
        // Video
        movieDurationSeconds += (parseInt(media.edu));
      }
    });
    // movieDurationSeconds += nPhotos * (defaultImagesDurationFrames / defaultFrameRate);
  }

  // Check if user can export video
  if (returnV) {
    if (!proUser && nPhotos > normalUserMaxPhotos) {
      returnV = false;
    }
    if (!proUser && movieDurationSeconds > normalUserMaxMovieDurationSeconds) {
      returnV = false;
    }
  }

  // Movie JSON pars
  const movieJsonPars = { allDataRemixPars, remixPars, un, app: BASE_APP, client: BASE_CLIENT, defaultImagesDurationFrames, defaultFrameRate };

  if (returnV && remixPars.uso && remixPars.usoid && allDataRemixPars && allDataRemixPars.getRemixApprovedElements && allDataRemixPars.getRemixApprovedElements.its_custom && allDataRemixPars.getRemixApprovedElements.its_custom.usoid) {
    movieJsonPars.customSong = true;
    movieJsonPars.customSongEid = allDataRemixPars.getRemixApprovedElements.its_custom.usoid;
  }

  // Generating the movieJson
  if (returnV) {
    if (parseInt(userData.save_exp_video) === 0) {
      movieJsonPars.shouldAddSaveExportedVideoKey = true;
      movieJsonPars.saveExportedVideo = 0;
    }
    try {
      movieJson = await MovieJSONBuilder(movieJsonPars);
    } catch (err) {
      console.error(err);
      returnV = false;
    }
  }

  // Generating arrays for createAlbum
  if (returnV) {
    rmxId = remixPars.rid;
    rmxMediaOnly = 1;
    const remixMedia = allDataRemixPars.getRemixApprovedElements.its_media;
    for (let i = 0; i < remixMedia.length; i ++) {
      const media = remixMedia[i];
      const { eid, etype } = media;
      if (eid && etype) {
        rmxElementIds.push(eid);
        rmxElementTypes.push(etype);

        if (etype === 1) {
          rmxFileNames.push(`photo_${i}.jpg`);
        } else if (etype === 2) {
          rmxFileNames.push(`video_${i}.mp4`);
        }
        
        rmxPhotoSortOrderIds.push(i);

        if (i === 0) {
          if (etype === 1) { albumCover = `photo_${i}.jpg`; }
          else if (etype === 2) { albumCover = `video_${i}.jpg`; }
        }
      }
    }
  }
  
  // Generating permission
  if (returnV) {
    const { rperm } = remixPars;
    if (parseInt(rperm) === 1) { albumPermission = 'private'; }
    else if (parseInt(rperm) === 2) { albumPermission = 'social'; }
    else if (parseInt(rperm) === 3) { albumPermission = 'public'; }
  }

  // Creating album
  if (returnV) {
    try {
      const pars = { un, al, movieJson, rmxElementIds, rmxElementTypes, rmxFileNames, rmxPhotoSortOrderIds, rmxMediaOnly, rmxId };
      pars.albumCommunityId = 1;
      pars.albumCommunityName = 'Photozig';
      pars.citId = 0;
      pars.albumName = remixPars.rti;
      pars.albumDesc =  RemixHelper.getRemixDescOnly(remixPars.rde);
      pars.albumDate =  RemixHelper.convertCreateDateToAlbumDate(remixPars.rcdate);
      pars.albumYear = RemixHelper.convertCreateDateToAlbumYear(remixPars.rcdate);
      pars.albumPerm = albumPermission;
      pars.albumNPhotos = nPhotos;
      pars.albumCover = albumCover;
      pars.albumSource = BASE_CLIENT;
      pars.hasMovie = true;

      const response = await WAM.createAlbum(pars);
      if (response && response.result === 'success') {
        if (response.album_id) { albumId = response.album_id; }
        if (response.album_movie_id) { movieId = response.album_movie_id; }
        if (response.album_movie_make_time) { movieMakeTime = response.album_movie_make_time; }
      } else {
        returnV = false;
      }
    } catch (err) {
      returnV = false;
      console.error(err);
    }
  }

  // Verifying status
  if (returnV) {
    do {
      // Waiting n seconds to check
      await timeout(secondsToWait * 1000);

      try {
        const pars = { un, al, albumId, movieId };
        const response = await WAM.uploadStatus(pars);
        if (response.result === 'success') {
          const { count_success } = response;
          if (count_success) {
            uploadStatusCount = parseInt(count_success);
          }
        }
      } catch (err) {
        console.error(err);
      }
    } while (uploadStatusCount < nPhotos);
  }

  // Step 6: wamPublishAlbum
  if (returnV) {
    try {
      const pars = { un, al, albumId, movieId, albumProtected: 0, doNotRepublish: 1, doNotPublishAlbum: 1 };
      const response = await WAM.publishAlbum(pars);
      if (response.result === 'success') {
        movieCreated = true;
      } else {
        movieCreated = false;
        returnV = false;
      }
    } catch (err) {
      returnV = false;
      console.error(err);
    }
  }

  const returnObj = { returnV, errorMessage, movieId, movieUrl, movieMakeTime, movieCreated };
  
  return returnObj;
}
